import { render, staticRenderFns } from "./ChengShu_usermana.vue?vue&type=template&id=07dff33d&scoped=true"
import script from "./ChengShu_usermana.vue?vue&type=script&lang=js"
export * from "./ChengShu_usermana.vue?vue&type=script&lang=js"
import style0 from "./ChengShu_usermana.vue?vue&type=style&index=0&id=07dff33d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dff33d",
  null
  
)

export default component.exports